/**
 * MULTI-JURISDICTION P6 — shared constant.
 *
 * The home zone chosen on the (unauthenticated) signup page is stashed here in
 * localStorage; the first authenticated load (PendingJurisdictionApplier) applies
 * it to the new tenant via `PUT /tenants/{id}/jurisdictions`. Kept in its own tiny
 * module so the always-mounted applier and the lazy SignupPage share the key
 * without cross-importing each other's chunk.
 */
export const PENDING_JURISDICTION_KEY = 'sgrc.pending_jurisdiction'
